import React from 'react';

type UseToggleReturn = [boolean, () => void];

const useToggle = (inititalValue: boolean = false): UseToggleReturn => {
  const [value, setValue] = React.useState<boolean>(inititalValue);

  const toggleValue = () => {
    setValue(previousValue => !previousValue);
  };

  return [value, toggleValue];
};

export default useToggle;
